import { Role } from '@core/roles/models/role.enum';

export interface MedalliaSurveyForm {
  username: string;
  role: string;
  salesforceID: string;
}

export interface MedalliaWindow {
  KAMPYLE_ONSITE_SDK: {
    showForm: (id: number) => void;
  };
  dataLayer: Array<MedalliaSurveyForm>;
}

export const userRoleToMedalliaUserRole: Record<Role, string> = {
  [Role.Admin]: 'Administrator',
  [Role.User]: 'Technician',
  [Role.BillingAndPurchasing]: 'End-User',
  [Role.CoManagedUser]: 'End-User',
};
